<template>
  <header :class="_cssClass" role="banner">
    <div v-if="showBuildInfo" class="theInfo no-print">
      <span ref="buildInfo" class="build-info"
        >Project: {{ project.version }} | Catalyst: {{ catalyst.version }}</span
      >
      <div ref="buildDetails" class="hidden build-details">
        <strong>Project</strong> - build ID: {{ project.buildId }}<br />
        build tag: {{ project.buildTag }}<br />
        built on: {{ project.builtOn }}<br />
        <hr class="divider" />
        <strong>Catalyst</strong> - build ID: {{ catalyst.buildId }}<br />
        build tag: {{ catalyst.buildTag }}<br />
        built on: {{ catalyst.builtOn }}
      </div>
    </div>
    <div class="header-container">
      <div class="header-row">
        <div class="header-cell-a">
          <div class="logo">
            <a
              :href="banner.href"
              :disabled="logoDisabled"
              :tabIndex="logoDisabled ? -1 : 0"
              :title="banner.cap"
              :data-button="banner.cap"
            >
              <img
                class="print-only logo-print"
                :src="
                  '/' +
                  appCode +
                  '/resource/app/images/' +
                  resolveTxt('skin.site.logoImgPrint.src', 'logo-bw.png')
                "
                :alt="resolveTxt('skin.site.logoImg.print.alt', '')"
              />
              <img
                class="print-hidden app-logo"
                :srcset="srcset"
                :src="
                  '/' +
                  appCode +
                  '/resource/app/images/' +
                  resolveTxt('skin.site.logoImg.src', 'logo.svg')
                "
                :sizes="
                  resolveTxt(
                    'skin.site.logoImg.sizes',
                    '(max-width: 640px) 120px, (min-width: 640px) 150px'
                  )
                "
                :alt="resolveTxt('skin.site.logoImg.alt', 'Verne logo')"
              />
            </a>
          </div>
          <div class="byline">{{ resolveTxt("skin.header.banner", "") }}</div>
        </div>
        <div class="header-cell-b no-print">
          <slot name="header-controls"></slot>
        </div>
      </div>
    </div>
  </header>
</template>
<script lang="ts">
import { defineComponent, inject } from "vue";
import tippy from "tippy.js";
import services from "@/components/services.js";

export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", services.resolveTxt);
    const displayParams = inject("displayParams", services.displayParams);
    const getService = inject("getService", services.getService);
    const getMenu = inject("getMenu", services.getMenu);

    return {
      resolveTxt,
      displayParams,
      getService,
      getMenu
    };
  },
  name: "CatHeader",
  props: {
    logoDisabled: {
      type: Boolean,
      default: false,
      description: "Logo link will be disabled if 'true'"
    },
    sticky: {
      type: Boolean,
      default: true,
      description:
        "fixed position if true (default) scrolls together with content if false - affects desktop devices only"
    }
  },
  data: function () {
    // Catalyst object may not have been on window when we initialised
    const api = window["Catalyst"];
    const banner = this.getMenu("banner") || false;
    return {
      appCode: api.appCode,
      showBuildInfo: api.showVersion,
      project: api.projectVersion,
      catalyst: api.catalystVersion,
      banner: banner
    };
  },

  mounted: function () {
    if (this.showBuildInfo) {
      const cont = this.$refs.buildDetails;
      const info = this.$refs.buildInfo;

      // guard against qtip not being present (such as when unit testing)
      if (tippy) {
        tippy(info, {
          content: cont.innerHTML,
          arrow: true,
          interactive: true
        });
      }
    }
  },
  computed: {
    _cssClass: function () {
      return {
        "cat-header": true,
        "not-sticky": !this.sticky
      };
    },
    srcset: function () {
      var _t = this;
      var srcsetArray = this.resolveTxt(
        "skin.site.logoImg.srcset",
        "logo-small.svg 130w, logo.svg 710w"
      ).split(",");
      srcsetArray.forEach(function (item, index) {
        srcsetArray[index] =
          "/" + _t.appCode + "/resource/app/images/" + item.trim();
      });
      return srcsetArray;
    }
  }
});
</script>
